import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: 32px;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 32px;
	overflow: hidden;
	height: 100%;
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const ListItem = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 0 0 16px 8px;
	height: 40px;
	min-height: 40px;
	box-sizing: border-box;
`;

export const TextTruncate = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Footer = styled.div`
	display: flex;
	border-top: 1px solid ${colors.grey3};
	justify-content: space-between;
	padding: 6px 32px;
`;

export const CheckboxLabel = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey8};
	letter-spacing: 0.3px;
	padding-left: 8px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ disabled }) =>
		disabled &&
		css`
			color: ${colors.grey5};
		`};
`;

export const SearchWrapper = styled.div`
	padding-bottom: 8px;

	> div {
		height: 40px;
	}

	button.ap-simple-search-search,
	button.ap-simple-search-clear {
		top: 11px;

		svg {
			fill: ${colors.grey6};
		}
	}

	input {
		border-radius: 0;
		border-color: ${colors.grey4};
		height: 40px;

		&:focus:enabled,
		& ~ button:focus:enabled {
			box-shadow: none;
		}

		&:focus,
		&:hover {
			border-color: ${colors.green2};
		}

		&:active {
			border-color: ${colors.green3};
		}

		&:disabled {
			pointer-events: none;
			color: ${colors.grey5};
			border-color: ${colors.grey2};
		}
	}
`;

export const NoDataWrapper = styled.div`
	padding: 8px 8px 16px 8px;
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
`;
